module.exports = __webpack_public_path__ + "static/media/que-hacer-en-tigre.a2f6cbc3.md";